import { system } from "portalframework";
import * as _ from "lodash";
import * as ko from "knockout";
import labels from "app/labels";
import { BaseService } from "./_common/_baseService";
import { AttachmentResultDTO, downloadAttachmentFromBase64 } from "./attachment.service";
import { CustomerReports, CustomerReportsSearchCriteria } from "organized";
import { portalHttpService } from "./_common/httpService";

class CustomerReportsService extends BaseService {
  constructor() {
    super("customerreports");
  }

  public getCustomerReports = async (): Promise<CustomerReports[]> => {
    const data = await portalHttpService.post<any>(system.apiURL() + "api/customerreports/GetCustomerReportsViews", {});
    if (data) {
      return _.map(data, (r) => {
        return new CustomerReports(r);
      });
    } else {
      throw new Error(labels.descr("cc_P_NO_RECORDS_FOUND"));
    }
  };

  public getCustomerReportData = async (criteria: CustomerReportsSearchCriteria): Promise<CustomerReports[]> => {
    const searchCriteria = ko.toJSON(criteria);
    const data = await portalHttpService.post<any>(`${this.baseApiUrl()}/GetCustomerReportViewData`, searchCriteria);
    return data;
  };

  public exportFile = async (criteria: CustomerReportsSearchCriteria): Promise<void> => {
    let url = "criteria=[" + ko.toJSON(criteria) + "]";
    const fileResult: AttachmentResultDTO = await portalHttpService.get<any>(`${this.baseApiUrl()}/ExportFile?${url}`);
    downloadAttachmentFromBase64(fileResult);
  };
}

export const customerReportsService = new CustomerReportsService();
